/* ============================================================
   SOS FILTER SEO
   Saddle Online Shop / TOMAR'S

   Permanent client-side behavior owner for filtered collections.

   SINGLE DATA SOURCE
   ------------------
   Shop metafield:
   custom.filter_seo_data

   Rendered into page by:
   snippets/sos-filter-seo-data.liquid

   JSON element:
   #SOSFilterSEOData

   OWNS
   ----
   - Reading shared filter SEO data
   - Gun-model filter detection
   - Barrel-length filter detection
   - Visible dynamic SEO block
   - Visible filtered breadcrumb synchronization
   - AJAX/history filter-change updates

   DOES NOT OWN
   ------------
   - Firearm names
   - Firearm SEO descriptions
   - Barrel SEO descriptions
   - Breadcrumb JSON-LD
   - Head canonical/title/meta

   IMPORTANT
   ---------
   Add or edit firearm/filter SEO data ONLY in:

   Shopify Admin
   Settings → General → Metafields
   → SOS Filter SEO Data

   ============================================================ */

(function () {
  'use strict';


  /* ==========================================================
     MASTER SEO DATA
     ========================================================== */

  const dataElement =
    document.getElementById('SOSFilterSEOData');


  let seoData = {
    models: {},
    barrels: {}
  };


  if (dataElement) {
    try {

      seoData =
        JSON.parse(
          dataElement.textContent
        );

    } catch (error) {

      console.error(
        'SOS Filter SEO data could not be parsed.',
        error
      );

    }
  }


  const models =
    seoData.models || {};


  const barrels =
    seoData.barrels || {};


  /* ==========================================================
     ACTIVE FILTER DETECTION
     ========================================================== */

  function getGunModelFromUrl() {

    const params =
      new URLSearchParams(
        window.location.search
      );


    const activeModels =
      params.getAll(
        'filter.p.m.custom.gun_model'
      );


    return activeModels.length
      ? activeModels[0].trim()
      : null;

  }


  function getBarrelLengthFromUrl() {

    const params =
      new URLSearchParams(
        window.location.search
      );


    const activeBarrels =
      params.getAll(
        'filter.p.m.custom.barrel_length'
      );


    return activeBarrels.length
      ? activeBarrels[0]
          .replace(/\+/g, ' ')
          .trim()
      : null;

  }


  /* ==========================================================
     VISIBLE SEO BLOCK
     ========================================================== */

  function insertSeoBlock(title, content) {

    const existing =
      document.querySelector(
        '.filter-seo-block'
      );


    if (existing) {
      existing.remove();
    }


    if (!title || !content) {
      return;
    }


    const block =
      document.createElement('div');

    block.className =
      'filter-seo-block';


    const heading =
      document.createElement('h2');

    heading.textContent =
      title;


    const paragraph =
      document.createElement('p');

    paragraph.textContent =
      content;


    block.appendChild(heading);
    block.appendChild(paragraph);


    const grid =
      document.querySelector(
        '#ProductGridContainer'
      );


    if (grid) {

      grid.insertAdjacentElement(
        'beforebegin',
        block
      );

    }

  }


  function updateSeoBlock() {

    const model =
      getGunModelFromUrl();


    const barrel =
      getBarrelLengthFromUrl();


    const existing =
      document.querySelector(
        '.filter-seo-block'
      );


    /* --------------------------------------------------------
       FIREARM MODEL
       -------------------------------------------------------- */

    if (
      model &&
      models[model]
    ) {

      const modelData =
        models[model];


      const displayName =
        modelData.display || model;


      const description =
        modelData.description || '';


      insertSeoBlock(
        `${displayName} Leather Holsters`,
        description
      );


      return;

    }


    /* --------------------------------------------------------
       BARREL LENGTH
       -------------------------------------------------------- */

    if (
      barrel &&
      barrels[barrel]
    ) {

      const barrelData =
        barrels[barrel];


      const description =
        barrelData.description || '';


      insertSeoBlock(
        `Leather Holsters for ${barrel} Barrels`,
        description
      );


      return;

    }


    /* --------------------------------------------------------
       NO SUPPORTED SEO FILTER
       -------------------------------------------------------- */

    if (existing) {
      existing.remove();
    }

  }


  /* ==========================================================
     VISIBLE BREADCRUMB SYNC
     ========================================================== */

  function updateBreadcrumb() {

    const breadcrumb =
      document.querySelector(
        '.sos-breadcrumbs'
      );


    if (!breadcrumb) {
      return;
    }


    const list =
      breadcrumb.querySelector(
        '.sos-breadcrumbs__list'
      );


    if (!list) {
      return;
    }


    /*
      The first breadcrumb is always Home.

      The collection breadcrumb generated by Liquid may initially
      contain either:

      Home › Collection

      or:

      Home › Collection › Firearm Model

      AJAX filter changes do not rerender Liquid, so we normalize
      the visible collection breadcrumb here.
    */


    const items =
      Array.from(
        list.querySelectorAll(
          ':scope > .sos-breadcrumbs__item'
        )
      );


    if (!items.length) {
      return;
    }


    const model =
      getGunModelFromUrl();


    /*
      Find the collection title.

      If Liquid initially rendered:
      Home › Collection › Model

      use the second item's text.

      If Liquid initially rendered:
      Home › Collection

      the second item's current text is the collection name.
    */

    let collectionName = '';


    if (items[1]) {

      const collectionLink =
        items[1].querySelector(
          '.sos-breadcrumbs__link'
        );


      const collectionCurrent =
        items[1].querySelector(
          '.sos-breadcrumbs__current'
        );


      collectionName =
        (
          collectionLink?.textContent ||
          collectionCurrent?.textContent ||
          ''
        ).trim();

    }


    /*
      Preserve the base collection URL.

      When Liquid rendered a filtered breadcrumb, the second item
      is already a link to the unfiltered collection.

      On an initially unfiltered collection, use the current path.
    */

    let collectionUrl =
      window.location.pathname;


    if (items[1]) {

      const existingCollectionLink =
        items[1].querySelector(
          '.sos-breadcrumbs__link'
        );


      if (
        existingCollectionLink &&
        existingCollectionLink.getAttribute('href')
      ) {

        collectionUrl =
          existingCollectionLink.getAttribute('href');

      }

    }


    /*
      Remove everything after Home.

      We rebuild only the collection portion so stale model
      breadcrumbs cannot survive an AJAX filter change.
    */

    while (list.children.length > 1) {

      list.removeChild(
        list.lastElementChild
      );

    }


    /*
      No gun-model filter:
      Home › Collection
    */

    if (
      !model ||
      !models[model]
    ) {

      if (!collectionName) {
        return;
      }


      const collectionItem =
        document.createElement('li');

      collectionItem.className =
        'sos-breadcrumbs__item';

      collectionItem.setAttribute(
        'aria-current',
        'page'
      );


      const collectionCurrent =
        document.createElement('span');

      collectionCurrent.className =
        'sos-breadcrumbs__current';

      collectionCurrent.textContent =
        collectionName;


      collectionItem.appendChild(
        collectionCurrent
      );


      list.appendChild(
        collectionItem
      );


      return;

    }


    /*
      Gun-model filter:
      Home › Collection › Firearm Leather Holsters
    */

    if (!collectionName) {
      return;
    }


    const collectionItem =
      document.createElement('li');

    collectionItem.className =
      'sos-breadcrumbs__item';


    const collectionLink =
      document.createElement('a');

    collectionLink.className =
      'sos-breadcrumbs__link';

    collectionLink.href =
      collectionUrl;

    collectionLink.textContent =
      collectionName;


    collectionItem.appendChild(
      collectionLink
    );


    list.appendChild(
      collectionItem
    );


    const modelData =
      models[model];


    const displayName =
      modelData.display || model;


    const modelItem =
      document.createElement('li');

    modelItem.className =
      'sos-breadcrumbs__item';

    modelItem.setAttribute(
      'aria-current',
      'page'
    );


    const modelCurrent =
      document.createElement('span');

    modelCurrent.className =
      'sos-breadcrumbs__current';

    modelCurrent.textContent =
      `${displayName} Leather Holsters`;


    modelItem.appendChild(
      modelCurrent
    );


    list.appendChild(
      modelItem
    );

  }


  /* ==========================================================
     MASTER UI UPDATE
     ========================================================== */

  function updateFilteredCollectionUI() {

    updateSeoBlock();
    updateBreadcrumb();

  }


  /* ==========================================================
     UPDATE SCHEDULER
     ========================================================== */

  let updateTimer = null;


  function scheduleUpdate(delay) {

    if (updateTimer) {

      window.clearTimeout(
        updateTimer
      );

    }


    updateTimer =
      window.setTimeout(
        function () {

          updateFilteredCollectionUI();

          updateTimer = null;

        },
        delay
      );

  }


  /* ==========================================================
     INITIAL LOAD
     ========================================================== */

  updateFilteredCollectionUI();


  /* ==========================================================
     HISTORY API
     ========================================================== */

  const originalPushState =
    history.pushState;


  const originalReplaceState =
    history.replaceState;


  history.pushState = function () {

    originalPushState.apply(
      this,
      arguments
    );


    scheduleUpdate(150);

  };


  history.replaceState = function () {

    originalReplaceState.apply(
      this,
      arguments
    );


    scheduleUpdate(150);

  };


  window.addEventListener(
    'popstate',
    function () {

      scheduleUpdate(150);

    }
  );


  /* ==========================================================
     SHOPIFY FILTER INTERACTION
     ========================================================== */

  document.addEventListener(
    'change',
    function () {

      scheduleUpdate(350);

    }
  );


  document.addEventListener(
    'click',
    function () {

      scheduleUpdate(500);

    }
  );


  /* ==========================================================
     AJAX DOM REPLACEMENT SAFETY NET

     Shopify collection filtering may replace product-grid DOM
     after history changes. Observe those replacements and
     resynchronize the SEO block + visible breadcrumb.
     ========================================================== */

  const observer =
    new MutationObserver(
      function (mutations) {

        let relevantChange =
          false;


        for (const mutation of mutations) {

          if (
            mutation.type !== 'childList' ||
            mutation.addedNodes.length === 0
          ) {
            continue;
          }


          for (
            const node
            of mutation.addedNodes
          ) {

            if (
              !(node instanceof Element)
            ) {
              continue;
            }


            if (
              node.matches(
                '#ProductGridContainer, .sos-breadcrumbs'
              ) ||
              node.querySelector(
                '#ProductGridContainer, .sos-breadcrumbs'
              )
            ) {

              relevantChange =
                true;

              break;

            }

          }


          if (relevantChange) {
            break;
          }

        }


        if (relevantChange) {

          scheduleUpdate(100);

        }

      }
    );


  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );


})();